import { render, staticRenderFns } from "./DashToggleButton.vue?vue&type=template&id=1353b2ea&scoped=true&"
import script from "./DashToggleButton.vue?vue&type=script&lang=js&"
export * from "./DashToggleButton.vue?vue&type=script&lang=js&"
import style0 from "./DashToggleButton.vue?vue&type=style&index=0&id=1353b2ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1353b2ea",
  null
  
)

export default component.exports